import React, { useEffect, useState, useContext } from 'react';
import {ConfigContext} from '../../DynamicForm/DynamicForm';
import { Field } from "formik";
import Required from "../../../../components/Required";
import RadioButtonGroup from "../../../../components/RadioButtonGroup";
import RadioButton from "../../../../components/RadioButton";
import Popover from "../../../../../formik/refactorOut/components/Popper/Popover";
import { popoverLocation } from '../../../../../config/Configuration';
import RadioField from '../../../../components/RadioField2/RadioField';
import { SectionHeader } from '../../../../components/sectionHeader/sectionHeader';
import ErrorBar from '../../../../components/ErrorBar';
import './DeliveryMethodSection.scss';
import { GetLanguageText } from '../../../../languages/languages';
import { CheckLanguage } from '../../../../languages/languages';

const DeliveryMethod = () => {
  
  const {formik, validationValues, dbFormSpec} = useContext(ConfigContext);
  const orgId = dbFormSpec.facility.orgId
  const triPartiteOrg = orgId.includes('7042') || orgId.includes ('7101') || orgId.includes('7239')

  useEffect(()=>{
    formik.values.releasemode == '2' && formik.values.discloseTo == '2' && formik.setFieldValue('releasemode', '') && formik.setFieldValue('releasemodePdf', '')
  }, [formik.values.discloseTo])
  const languageID = CheckLanguage(dbFormSpec);



  if (languageID != "default") {
    const languageText = GetLanguageText(languageID);
  return (
    validationValues.page.form.sections.deliveryMethodSection.active ?
      <div id='deliveryMethodGroup' className='deliveryMethodSection form-section'>
        <SectionHeader sectionTitle={`${languageText.deliveryMethod.label}`} styles={{ color: dbFormSpec.color }} />
        {formik.errors.releasemodePdf && formik.touched.releasemodePdf && <ErrorBar message={formik.errors.releasemodePdf}/>}
        <p className='section-instruction subtitle1'>{languageText.deliveryMethod.options.option1}</p>
          <div className="form-group">

            {dbFormSpec.deliveryMethods ?
              Object.entries(dbFormSpec.deliveryMethods).map((method)=>{
                if (method[1].active) {
                    return <RadioField label={method[0].replaceAll('_', ' ')} id={'deliveryMethod'} fieldValue={method[1].value} formValue={'releasemodePdf'} formik={formik} orgColor={dbFormSpec.color} hoverTip={method[1].tooltip ? method[1].tooltip : false} />
                }
              })
              :
              <>
                {formik.values.discloseTo !== '2' && <RadioField label={`${languageText.deliveryMethod.options.option2}`} id={'deliveryMethod'} fieldValue={'2'} formValue={'releasemodePdf'} formik={formik} orgColor={dbFormSpec.color} />}
                <RadioField label={`${languageText.deliveryMethod.options.option3}`} id={'deliveryMethod'} fieldValue={'5'} formValue={'releasemodePdf'} formik={formik} orgColor={dbFormSpec.color} />
                <RadioField label={`${languageText.deliveryMethod.options.option4}`} id={'deliveryMethod'} fieldValue={'7'} formValue={'releasemodePdf'} formik={formik} orgColor={dbFormSpec.color} />
                {triPartiteOrg && <RadioField label={'Fax'} id={'deliveryMethod'} fieldValue={'12'} formValue={'releasemodePdf'} formik={formik} orgColor={dbFormSpec.color} />}
                {orgId != '1007307' && orgId != '1007042' && <RadioField label={`${languageText.deliveryMethod.options.option5}`} id={'deliveryMethod'} fieldValue={'4'} formValue={'releasemodePdf'} formik={formik} orgColor={dbFormSpec.color}/>} 
              </>
                  }

            {formik.touched.deliveryMethodGroup &&
              formik.errors.deliveryMethodGroup ? (
              <span className="input-error-text">
                {formik.errors.deliveryMethodGroup}
              </span>
            ) : null}
          </div>
          {formik.values.releasemode === '4' && `${languageText.ErrorChecking.ValidatorText.repcontact}`}
      </div>
      :
      <></>
  );
  } else {

    
  return (
    validationValues.page.form.sections.deliveryMethodSection.active ?
      <div id='deliveryMethodGroup' className='deliveryMethodSection form-section'>

        <SectionHeader sectionTitle={'Delivery Method'} styles={{ color: dbFormSpec.color }} />
        {/* <div> */}
        {formik.errors.releasemodePdf && formik.touched.releasemodePdf && <ErrorBar message={formik.errors.releasemodePdf}/>}
        <p className='section-instruction subtitle1'>Select the method of delivery for the records</p>

          {/* <label>
            <span style={template.styles.label}>{template.fields.deliveryMethodGroup.label}</span>{" "}
            <Required value={true} />
          </label> */}

          <div className="form-group">

            {dbFormSpec.deliveryMethods ?
              Object.entries(dbFormSpec.deliveryMethods).map((method, index)=>{
                if (method[1].active) {
                    return <RadioField key={index +"deliveryMethods" } label={method[0].replaceAll('_', ' ')} id={'deliveryMethod'} fieldValue={method[1].value} formValue={'releasemodePdf'} formik={formik} orgColor={dbFormSpec.color} hoverTip={method[1].tooltip ? method[1].tooltip : false}/>
                }
              })
              :
              <>
                {/* {formik.values.discloseTo !== '2' && */ <RadioField label={'Electronic copy of records'} id={'deliveryMethod'} fieldValue={'2'} formValue={'releasemodePdf'} formik={formik} orgColor={dbFormSpec.color} />}
                <RadioField label={'Mail Paper Records'} id={'deliveryMethod'} fieldValue={'5'} formValue={'releasemodePdf'} formik={formik} orgColor={dbFormSpec.color} />
                <RadioField label={'CD/DVD'} id={'deliveryMethod'} fieldValue={'7'} formValue={'releasemodePdf'} formik={formik} orgColor={dbFormSpec.color} />
                {triPartiteOrg && <RadioField label={'Fax'} id={'deliveryMethod'} fieldValue={'12'} formValue={'releasemodePdf'} formik={formik} orgColor={dbFormSpec.color} />}
                {orgId != '1007307' && orgId != '1007042' && <RadioField label={`Pickup on Site`} id={'deliveryMethod'} fieldValue={'4'} formValue={'releasemodePdf'} formik={formik} orgColor={dbFormSpec.color}/>} 
              </>
            }            
            

            {formik.touched.deliveryMethodGroup &&
              formik.errors.deliveryMethodGroup ? (
              <span className="input-error-text">
                {formik.errors.deliveryMethodGroup}
              </span>
            ) : null}
          </div>
          {formik.values.releasemode === '4' && 'A representative will contact you to schedule date, time and location of pickup'}

        {/* </div> */}
      </div>
      :
      <></>
  );

  }

};

export default DeliveryMethod;
